import { useEffect } from 'react';
import { getCookie } from '../utils/cookie';
import { MAX_USER_SESSIONS_COUNT_FOR_UXFB, UXFB_USER_SESSION_COUNTER_COOKIE } from '../constants/uxfb';
import { setCookie } from '@cian/utils/lib/browser/cookie';

/** Обновляем счетчик сессий пользователя для uxfb */
export const useUxfbUserSessionsUpdater = () => {
  useEffect(() => {
    const userSessionCookie = getCookie(UXFB_USER_SESSION_COUNTER_COOKIE);
    const userSessionsCount = Number(userSessionCookie) || 0;

    if (userSessionsCount < MAX_USER_SESSIONS_COUNT_FOR_UXFB) {
      setCookie(UXFB_USER_SESSION_COUNTER_COOKIE, `${userSessionsCount + 1}`);
    }
  }, []);
};
